<div class="activity-edition-preview-fill-blanks__sentence-wrapper">
    <p class="activity-edition-preview-fill-blanks__sentence" [innerHTML]="getSentence()"></p>
</div>